import type { SVGProps } from 'react';
const SvgMapMarker = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M17.656 2.344C16.147.832 14.137 0 12 0S7.853.831 6.344 2.344A7.944 7.944 0 0 0 4 8c0 2.669 1.222 6.119 3.638 10.253 1.762 3.022 3.5 5.266 3.575 5.359a1.003 1.003 0 0 0 1.582 0c.072-.094 1.812-2.337 3.575-5.359 2.409-4.134 3.631-7.584 3.631-10.253a7.933 7.933 0 0 0-2.344-5.656zM12 21.312C10.209 18.8 6 12.421 6 7.999c0-3.309 2.691-6 6-6s6 2.691 6 6c0 4.422-4.209 10.8-6 13.313z" />
    <path d="M12 4C9.794 4 8 5.794 8 8s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 7c-1.653 0-3-1.347-3-3s1.347-3 3-3 3 1.347 3 3-1.347 3-3 3z" />
  </svg>
);
export default SvgMapMarker;
